import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import { BiX } from "react-icons/bi";
import "../css/RoomModal.css";
import { QRCodeCanvas } from "qrcode.react";
import { Printer } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { downloadPDF } from "../../../utils/exportUtils";

export default function QRModal({ open, onClose, qrUrl, title, description }) {
  const { t } = useTranslation();
  const printableRef = useRef();

  const handleClose = () => {
    onClose();
  };

  const handleDownloadPDF = () => {
    const element = printableRef.current;

    const hiddenElements = element.querySelectorAll(".no-print");

    hiddenElements.forEach((el) => (el.style.display = "none"));

    downloadPDF(element, "attendance.pdf");

    // restore after export
    setTimeout(() => {
      hiddenElements.forEach((el) => (el.style.display = ""));
    }, 1000);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modalStyle" sx={{ width: "35%", textAlign: "center" }}>
        <Box ref={printableRef}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
          >
            <Typography variant="h5" fontWeight="bold" color="secondary">
              {title}
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <BiX />
            </IconButton>
          </Box>

          {qrUrl && (
            <Box
              id="qr-printable"
              display="flex"
              flexDirection="column"
              gap={3}
              sx={{ alignItems: "center" }}
            >
              <QRCodeCanvas
                value={qrUrl}
                size={256}
                fgColor="#6F2E8F"
                bgColor="#ffffff"
                level="H"
              />
              <Typography variant="body1" fontWeight="bold" color="secondary">
                {description}
              </Typography>

              <Button
                onClick={handleDownloadPDF}
                variant="contained"
                startIcon={<Printer />}
                className="no-print"
                sx={{
                  borderRadius: "50px",
                  px: 3,
                  fontSize: "0.8125em",
                  textTransform: "None",
                }}
              >
                {t("buttons.export_pdf")}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
